import { Heading, Stack, Text } from "@chakra-ui/react";

import CustomWrapper from "components/Chakra/CustomWrapper";

const Timeline = () => (
  <CustomWrapper
    maxW="1360px"
    mb={{ base: "80px", md: "120px" }}
    contentProps={{
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      flexDirection: { base: "column", md: "row" },
      gap: "40px",
    }}
  >
    <Heading maxW={{ base: "100%", md: "325px" }} display="flex">
      Profesionální podklady do 3 dnů
    </Heading>

    <Stack
      position="relative"
      borderLeft="1px solid black"
      spacing={0}
      gap={{ base: "24px", md: "40px" }}
      maxW={{ base: "100%", md: "325px" }}
      h="calc(100% - 20px)"
    >
      <Text pl="16px" mt="-5px" fontWeight="bold">
        <Text
          as="span"
          position="absolute"
          left="-5px"
          top={0}
          h="10px"
          w="10px"
          borderRadius="50%"
          bg="linear-gradient(86deg, #E74C3C 0%, #E98540 100%)"
          display="inline-block"
        />
        Domluvíme spolu schůzku na nemovitosti
      </Text>
      <Text pb="8px" pl="16px" fontWeight="bold" position="relative">
        <Text
          as="span"
          h="10px"
          left="-5px"
          position="absolute"
          bottom="15px"
          w="10px"
          borderRadius="50%"
          bg="linear-gradient(86deg, #E74C3C 0%, #E98540 100%)"
          display="inline-block"
        />
        Během pár hodin vytvoříme snímky
      </Text>
      <Text pl="16px" fontWeight="bold">
        <Text
          as="span"
          h="10px"
          left="-5px"
          position="absolute"
          bottom={0}
          w="10px"
          borderRadius="50%"
          bg="linear-gradient(86deg, #E74C3C 0%, #E98540 100%)"
          display="inline-block"
        />
        Do 3 dnů vám všechny materiály pošleme online ke stažení
      </Text>
    </Stack>
  </CustomWrapper>
);

export default Timeline;
